import { caZipCodeRegExp } from '../ContactDetailsStep/validation';

export const formatCAZipCode = (zipcode: string) => {
  // removes dashes and spaces, changes to uppercase
  const value = zipcode.replace(/[-\s]/g, '').toUpperCase();

  // returns as A1A 1A1
  return `${value.slice(0, 3)} ${value.slice(3)}`;

  /* Examples:
  a1a 1a1, a1a-1a1, a1a1a1 => A1A 1A1
  */
};

export const isZipCodeCanadian = (value: string) => {
  return caZipCodeRegExp.test(value);
};
